import { mockRiskLevels } from '@/lib/demo-data/risk-levels';
import { useApi } from './useApi';
import { useModeAwareQuery } from './useModeAwareQuery';

export interface RiskLevelOption {
  id: number;
  code: string;
  name: string;
  description?: string;
  sortOrder: number;
}

interface RiskLevelApiResponse {
  id: number;
  code: string;
  name: string;
  description?: string;
  sortOrder: number;
}

export function useRiskLevels() {
  const { apiGet } = useApi();

  return useModeAwareQuery<RiskLevelOption[], Error>(
    ['risk-levels'],
    async ({ signal }) => {
      const response = await apiGet<RiskLevelApiResponse[]>('/api/v1/risk-levels', undefined, signal);
      return response.map((x) => ({
        id: x.id,
        code: x.code,
        name: x.name,
        description: x.description,
        sortOrder: x.sortOrder,
      }));
    },
    mockRiskLevels,
    { staleTime: 60 * 1000, refetchOnWindowFocus: false },
  );
}
